import { ErrorDialogStyle } from '@/components/organisms/dialog/style'

interface ModalConfigOn {
  show: true,
  onClose: () => void,
  message: string,
  style?: ModalStyle
}

interface ModalConfigOff {
  show: false,
}

export type ModalConfig = ModalConfigOn | ModalConfigOff

type ModalStyle = ErrorDialogStyle

export const styleAsWarning: ModalStyle =  {
  container: {
    backgroundColor: '#51c467',
  },
  closeButton: {
    backgroundColor: '#51c467',
  },
  closeButtonText: {
    color: '#51c467',
  },
}
